// home.js
import React from 'react';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import Employees from './Employees';
import EmployeePayments from './EmployeePayments';
import IndividualEmployeePayment from './IndividualEmployeePayment';
import SelectionProcess from './SelectionProcess';
import PositionsPlan from './PositionsPlan';

const HumanResource = ({ activeTab, setActiveTab, showNav }) => {
    return (
        <div
             className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'employees'
                            })}
                            onClick={() => {
                                setActiveTab('employees');
                            }}
                        >
                            Colaboradores
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'employeepayments'
                            })}
                            onClick={() => {
                                setActiveTab('employeepayments');
                            }}
                        >
                            Folha de Pagamento
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active:
                                    activeTab === 'individualemployeepayment'
                            })}
                            onClick={() => {
                                setActiveTab('individualemployeepayment');
                            }}
                        >
                            Ficha Salarial
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'selectionprocess'
                            })}
                            onClick={() => {
                                setActiveTab('selectionprocess');
                            }}
                        >
                            Processos Seletivos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: activeTab === 'positionsplan'
                            })}
                            onClick={() => {
                                setActiveTab('positionsplan');
                            }}
                        >
                            Cargos e Salários
                        </NavLink>
                    </NavItem>
                </Nav>
            )}
            <TabContent activeTab={activeTab} className="bg-white">
                <TabPane tabId="employees">
                    <Col sm="12">
                        <Employees />
                    </Col>
                </TabPane>
                <TabPane tabId="employeepayments">
                    <Col sm="12">
                        <EmployeePayments />
                    </Col>
                </TabPane>
                <TabPane tabId="individualemployeepayment">
                    <Col sm="12">
                        <IndividualEmployeePayment />
                    </Col>
                </TabPane>
                <TabPane tabId="selectionprocess">
                    <Col sm="12">
                        <SelectionProcess />
                    </Col>
                </TabPane>
                <TabPane tabId="positionsplan">
                    <Col sm="12">
                        <PositionsPlan />
                    </Col>
                </TabPane>
            </TabContent>
        </div>
    );
};

export default HumanResource;
